import React from 'react';
import classNames from 'classnames';

import { Button } from 'components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/pro-regular-svg-icons';

export type SortDirection = 'asc' | 'desc' | null;

const ARIA_SORT = { asc: 'ascending', desc: 'descending' } as const;
const ICONS = { asc: faSortUp, desc: faSortDown };

interface Props {
  direction: SortDirection;
  label: string;
  onSort: () => void;
}

export default function SortableHeader({ direction, label, onSort }: Props) {
  return (
    <th aria-sort={direction ? ARIA_SORT[direction] : undefined} className="text-nowrap">
      <Button className="p-0 fw-semibold text-body" variant="ghost" onClick={onSort}>
        {label}
        <FontAwesomeIcon
          className={classNames({ 'text-muted opacity-50': !direction })}
          icon={direction ? ICONS[direction] : faSort}
        />
      </Button>
    </th>
  );
}
